
import React from "react";
import { UserSettings } from "@/components/settings/users/UserSettings";
import { useAuth } from "@/hooks/useAuth";
import { Navigate } from "react-router-dom";

const Users = () => {
  const { currentUser,loading } = useAuth();
  
  if (!loading && (!currentUser || (currentUser.type !== 'super_admin' && currentUser.type !== 'admin'))) {
    return <Navigate to="/" replace />;
  }
  
  return (
    <div className="space-y-6 p-4 md:p-8">
      <div>
        <h2 className="text-3xl font-bold">Usuários</h2>
        <p className="text-muted-foreground">
          {currentUser?.type === 'super_admin' 
            ? "Gerencie todos os usuários do sistema"
            : "Gerencie os usuários da sua empresa"}
        </p>
      </div>
      <UserSettings />
    </div>
  );
};

export default Users;
